.codeInput {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 22px;
  letter-spacing: 0.25em;
  text-align: center;
  max-width: 220px;
}
.setup {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 24px;
  align-items: start;
}
.qr {
  width: 200px;
  height: 200px;
  border-radius: 16px;
  border: 1px solid var(--color-line);
  background: #fff;
}
.secret {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 15px;
  word-break: break-all;
  background: var(--color-hover-bg);
  border-radius: 10px;
  padding: 8px 10px;
}
.codes {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 24px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 17px;
  list-style: none;
  padding: 16px;
  margin: 0;
  border-radius: 16px;
  background: var(--color-hover-bg);
}
.apps {
  color: var(--color-muted);
  font-size: 14px;
}
@media (max-width: 640px) {
  .setup {
    grid-template-columns: 1fr;
  }
}
